import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useMemo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";


import { themeSettings } from "theme";
import Home from "scenes/homePage/HomePage";
import AdminCalendarPage from "scenes/admin/AdminPage";
import Login from "scenes/auth";

import { signIn, setUserInfo, logOut } from "./state";
import RequireAdmin from "components/RequireAdmin";
import RequireGuest from "components/RequireGuest";
import BookingCalendarPage from "scenes/booking/BookingPage";
import Layout from "components/layout/Layout";
import Prices from "scenes/prices/prices";
import Contact from "scenes/contact/Contact";
import GalleryPage from "scenes/gallery/GalleryPage";
import FAQPage from "scenes/FAQPage";

function App() {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.global.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  const [appReady, setAppReady] = useState(false);

  useEffect(() => {
    const restoreSession = () => {
      const storedToken = sessionStorage.getItem("token");
      if (!storedToken) return;

      try {
        const tokenData = JSON.parse(atob(storedToken.split(".")[1]));
        const isTokenValid = tokenData.exp * 1000 > Date.now();

        if (!isTokenValid) {
          sessionStorage.clear();
          dispatch(logOut());
          return;
        }

        dispatch(signIn(storedToken));

        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
          const userData = JSON.parse(userDataString);
          dispatch(setUserInfo(userData));
        }
      } catch (err) {
        console.error("Session restore error:", err);
        sessionStorage.clear();
        dispatch(logOut());
      }
    };

    restoreSession();
    setAppReady(true);
  }, [dispatch]);

  if (!appReady) return null;

  return (
    <div className="app">
      <Router>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            {/* Auth route - outside any layout */}
            <Route
              path="/auth"
              element={
                <RequireGuest>
                  <Login />
                </RequireGuest>
              }
            />

            {/* Global Layout */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/reserver" element={<BookingCalendarPage />} />
              <Route path="/tarifs" element={<Prices />} />
              <Route path="/galerie" element={<GalleryPage />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<FAQPage />} />

              {/* Admin Route */}
              <Route
                path="/admin"
                element={
                  <RequireAdmin>
                    <AdminCalendarPage />
                  </RequireAdmin>
                }
              />
            </Route>
          </Routes>
        </ThemeProvider>
      </Router>
    </div>
  );
}

export default App;
